export default {
    tabbar: {
        home: 'Casa',
        trading: 'Comercio',
        invest: 'Invertir',
        share: 'Cuota',
        mine: 'Mia'
    },
    common: {
        deposit: 'Depositar',
        withdrawal: 'Retiro',
        share: 'Cuota',
        team: 'Equipo',
        task: 'Tareas',
        addr: 'DIRECCIÓN',
        logout: 'Desconexión',
        wallet: 'Cartera',
        account: 'Cuentas',
        promotion: 'Promoción',
        details: 'Detalles',
        dailyRevenue: 'Ingresos diarios',
        dailyRevenueList: 'Lista diaria de ingresos',
        aboutUs: 'Sobre nosotros',
        globalPartners: 'Asociados mundiales',
        totalBalance: 'Saldo total',
        profitList: 'Estado de resultados financieros',
        notification: 'Notificación',
        previous: 'Anterior',
        close: 'Aproximación',
        next: 'Siguiente',
        investWallet: 'Cartera de inversiones',
        financialWallet: 'Cartera financiera',
        recharge: 'Carga',
        copySucceeded: 'Copia exitosa',
        copyFailed: 'Falló la replicación',
        promotionWallet: 'Cartera promocional',
        registerRewardWallet: 'Cartera de premios de registro',
        toAddress: 'Dirección de la cartera TRON para la colección (comenzando con t)',
        verifyYourPassword: 'Verificar su contraseña de Seguridad',
        serviceFee: 'Gas fees',
        confirm: 'Confirmar',
        submitted: 'Submission',
        date: 'Fecha',
        amount: 'Cantidad',
        accountAvailableBalance: 'Saldo disponible de la cuenta',
        securityPassword: 'Contraseña de Seguridad',
        withdrawalPrincipal: 'Extracción del principal',
        withdrawalProfit: 'Extraer beneficios',
        profitRate: 'Tasa de interés',
        notificationAndFAQ: 'Preguntas frecuentes y avisos',
        FAQ: 'Preguntas frecuentes',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Características/introducción del proyecto',
                content: `R:
1. Como el primer código de inversión auditado probado de la industria, nuestra solución tiene como objetivo demostrar que los contratos inteligentes son el futuro de la inversión. Su longevidad y estabilidad, en última instancia, alterarán la industria de las criptomonedas y la forma en que la gente piensa sobre la inversión y el comercio. La industria de tokens convencional enfrenta muchos desafíos, incluidas estafas de tokens, alfombras, volatilidad del mercado, desarrolladores deshonestos que roban fondos de los usuarios y falta de liquidez.

2. El código de confiabilidad que tenemos se basa en la estructura de la solución y nuestra solución no se verá afectada de ninguna manera por estos y muchos otros desafíos que surgen en la industria de la criptografía. Nuestra plataforma no requiere liquidez del mercado. Por lo tanto, su inversión y sus ingresos esperados están seguros porque no dependemos de los cambios en la industria. En lugar de eso, creamos una solución basada en el atractivo para nuevos usuarios pero que funciona con contratos inteligentes. Nuestro código y estructura son seguros, con longevidad y transparencia garantizadas. Por lo tanto, tenemos un programa de referencias muy atractivo y sólido con estadísticas detalladas y transparentes para cada promotor/usuario. Las ganancias del originador, así como las de otros usuarios, se agregan instantáneamente al perfil y, a diferencia de otras soluciones de inversión DeFi, las personas pueden retirar fondos instantáneamente en cualquier momento.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:¿Cuál es nuestra ventaja?',
                content: `R:Nuestros sistemas son auditados por el equipo de seguridad de Haze y cuentan con auditores independientes de Smart Contract
1. Seguro y confiable: no es necesario transferir moneda, el USDT se deposita en su propia billetera sin riesgo
2. Estabilidad profesional: equipo profesional, funcionamiento estable durante todo el año.
3. Umbral de entrada bajo: compartir los ingresos mineros del nodo
4.USD ETHW AI Strategy-C Mining Pool: no es necesario transferir moneda, ingresos estables
5. Estamos comprometidos a construir la plataforma DeFi integrada más grande del mundo, DEX, IMO y DAO.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:¿Cómo me involucro?',
                content: `R:
1. La billetera está en la cadena y la estación de billetera está equipada con un navegador Dapp.
2. Conecte TRC20 a USDT y deposítelo en su billetera
3. Ingrese a Gongwang a través del navegador de billetera.
4. Su billetera debe tener más de 30 trx como tarifas de minería para participar en este proyecto.
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:¿Cuánto tiempo lleva participar en la minería?',
                content: `R:No se puede calcular el tiempo. Normalmente se puede completar en 4 horas. Si se encuentran otras razones inciertas, el tiempo puede ampliarse.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:¿Por qué tenemos que pagar tarifas mineras para retirar las ganancias?',
                content: `R:Porque en este proceso de participación en la minería, los clientes solo se cuentan por su nombre y las tarifas mineras generadas han sido pagadas por los mineros. Los ingresos generados están en realidad en el grupo de contratos, y solo pagando tarifas de minería se pueden intercambiar por ingresos.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:¿Cómo retirar ganancias?',
                content: `R:Después de obtener USDT, debes tener una pequeña cantidad de TRX en tu billetera para cubrir las tarifas de transacción. Solo necesita pagar una vez y el intercambio de USDT se completará dentro de un día hábil legal. Cuando inicia un retiro, el retiro de USDT se enviará automáticamente a la dirección de billetera del nodo al que se unió. No se admiten otras direcciones.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:¿Qué es la minería de liquidez Defi?',
                content: `R:La minería de liquidez es un tipo de financiación descentralizada DeFi. No necesita comprar tarjetas gráficas, aportar potencia informática ni pagar costosas facturas de electricidad, sino que obtiene ingresos proporcionando fondos y liquidez. Especialmente recientemente, los precios de las divisas han fluctuado mucho. Para algunos poseedores de monedas comprometidos, la minería de liquidez es una forma de obtener ingresos y acumular más criptomonedas sin necesidad de realizar transacciones.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:¿Como funciona?',
                content: `R:Nuestra solución es un acuerdo de transacción computarizado que automáticamente hace cumplir los términos de un contrato entre dos partes. Al igual que en los contratos universales, ambos usuarios de nuestra plataforma deben definir las reglas y términos de participación al operar. Una vez que se llega a un acuerdo y se lanza un contrato inteligente, este funciona según lo diseñado, sin posibilidad de cambios en las condiciones predeterminadas. Cuando un usuario inicia una actividad en el pool de minería de un nodo blockchain, debe haber un saldo disponible en el contrato. El resto de usuarios dejan que el contrato se ejecute, sin tener que esperar largas horas para comprobar cuándo vender o comprar. Por lo tanto, según los términos del contrato, se garantiza que el valor de su inversión nunca disminuirá; al contrario, aporta un 100% de beneficios a nuestros usuarios.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'El monto del retiro debe ser mayor que la tarifa de gas consumida.',
        supportTips: 'Estimado usuario: Hemos configurado un servicio exclusivo de asistente de pool de minería para usted. Puede escribirnos para consultas, quejas, sugerencias, etc., ¡le responderemos y lo manejaremos dentro de las 24 horas!',
        tips: 'Consejos',
        Withdrawals_prohibited: 'Las condiciones de retiro no se cumplen actualmente; primero complete la tarea.'
    },
    homePage: {
        theCommonProblem: 'Preguntas frecuentes',
        latestAnnouncement: 'El último anuncio',
        block5title: 'Únete a ser millonario.',
        block5desc: 'Utilice la tecnología Cloud Mining y defi para asegurar que todos los usuarios obtengan los mayores ingresos USDT.',
        block6title: 'Visualización de datos de la plataforma',
        accumulatedProfit: 'Beneficio acumulado',
        membership: 'Miembro',
        block7title: 'Estamos en nuestro mejor momento.',
        block7desc: 'hako es una empresa registrada en Singapur, número de licencia: PS20200556. Somos el único sitio web de inversión en contratos inteligentes auditado y verificado en el espacio de las criptomonedas que opera en la red TRON Smart Chain (TRON). Hako Cloud Mining ofrece un canal de minería potencialmente rentable para Bitcoin USDT y otras criptomonedas. Al mismo tiempo, tanto el comercio cuantitativo como la tecnología DeFi le permitirán participar fácilmente en transacciones blockchain con una pequeña cantidad de capital y obtener ingresos estables, como seguros.',
        tzl: 'inversión en',
        zl: 'Ganó'
    },
    investPage: {
        productList: 'Lista de productos',
        investedList: 'Lista de inversiones',
        dailyRate: 'Tasa diaria',
        cycle: 'Período',
        day: 'Un día',
        productDetails: 'Detalles del producto'
    },
    tradingPage: {
        miningWorking: 'La minería en la nube está en juego',
        tradingProfit: 'Beneficios comerciales',
        settlementRule: 'Liquidación de 24 horas',
        viewAll: 'Ver todo',
        quantifyingTransactionRevenue: 'Ingresos comerciales cualitativos',
        receive: 'Recepción',
        received: 'Recibido',
        rule: 'Reglas mineras',
        rules: 'Si desea que "Cloud Mining" comience a funcionar y le genere ingresos diarios, actívelo en "Financial Wallet". Cuando el saldo de USDT en su billetera cumpla con ciertas condiciones, recibirá un ingreso diario y los ingresos generados se retendrán durante 30 días. Haga clic para reclamarlo a tiempo. Calcule su porcentaje de ingresos diarios según la siguiente tabla:',
        profit: 'Ganancia',
        miningNotWorking: 'La minería en la nube no funciona, actívela',
        balance: 'balance'
    },
    sharePage: {
        text1: 'Invite a sus contactos',
        text2: 'O amigos, y recibir recompensas',
        text3: 'Recomendar y recibir premios',
        text4: 'Comparta sus enlaces de recomendación y comience a ganar dinero',
        copyLink: 'Copiar enlace'
    },
    minePage: {
        trxDepositInvestment: 'USDT Deposit Investment',
        trxDepositFinancial: 'USDT Deposit Finance',
        tips: 'Recargar cualquier número de USDT para activar la cuenta y abrir la función de retiro.',
        appServices: 'Servicios de aplicaciones'
    },
    depositPage: {
        text1: 'La inversión se divide en dos modos',
        text2: '1:Recargar en su cartera de inversión le permite obtener beneficios en diferentes ciclos, devolviendo el principal y los ingresos al vencimiento',
        text3: '2: Active la función "minería en la nube" en su billetera financiera y reciba ingresos según la zona horaria de Singapur (después de las 12 en punto) todos los días',
        text4: 'Notas:',
        text5: 'Antes de invertir, seleccione una cuenta de inversión o una cuenta financiera para invertir de acuerdo a sus necesidades de inversión. Asegúrese de esperar a que su cuenta sea recargada. Esta es una cuestión muy crítica. '
    },
    rechargePage: {
        trxAddress: 'Dirección TRC20-USDT',
        copyAddress: 'Dirección de copia',
        tips1: 'Por favor, no recargar otros activos no USDT. El registro se lleva a cabo aproximadamente 5 - 10 minutos después de la carga.',
        tips2: `Si no llega por mucho tiempo, actualice esta página. Inversión mínima de 5 USDT.`,
        rechargeCompleted: 'Carga completa',
        inactivated: 'Inactivado',
        activated: 'Activada',
        tips3: 'No es necesario hacer clic repetidamente. La minería en la nube comienza a funcionar entre 5 y 10 minutos después de que se envía la solicitud.',
        tips4: 'Si no se ha activado durante mucho tiempo, haga clic nuevamente en el botón Activar.',
        ActivateCloudMining: 'Activar la minería en la nube'
    },
    withdrawalPage: {
        text1: 'Saldo básico de la cuenta (USDT)',
        text2: 'Los retiros se recibirán en un plazo de 24 horas',
        dailyWithdrawalLimit: 'Límite diario de retirada',
        unlimit: 'Sin restricciones'
    },
    teamPage: {
        intro: 'Los usuarios que invite directa e indirectamente pueden obtener dividendos para usted. Supongamos que invita al usuario A, los ingresos financieros obtenidos por el usuario A se enviarán a su billetera como un porcentaje de recompensa. Si el usuario A invita al usuario B y B, a su vez, invita a C, puede obtener A ({lev2rate}%), B ({lev3rate}%), C ({lev4rate}%) una recompensa porcentual de los ingresos del usuario.',
        level: 'Nivelador',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'Cantidad',
        rewards: 'Rewards'
    },
    productDetailsPage: {
        startingAmount: 'Importe inicial',
        maxInvestmentAmount: 'Inversión máxima',
        dailyInterestRate: 'Tipo de interés diario',
        investableQuantity: 'Cantidad invertible',
        investmentAmount: 'Inversión',
        participateInInvestment: 'Participación en la inversión'
    },
    investedListPage: {
        investmentTime: 'Tiempo de inversión',
        settlementTime: 'Tiempo de liquidación',
        settlementAmount: 'Importe de la liquidación'
    },
    loginPage: {
        MobileNumber: 'Número de teléfono móvil',
        LoginPassword: 'Contraseña de inicio de sesión',
        SignIn: 'Iniciar sesión',
        SignUp: 'Registro',
        rememberThePassword: ' Recuerde la contraseña',
        inviteCode: 'Código de invitación',
        captcha: 'Código de verificación',
        EncryptedRegistration: 'Registro cifrado',
        desc: 'Las contraseñas se almacenan en tuberías dispersas y no se pueden recuperar cuando se pierden. Por favor, recuerde su contraseña. ',
        registerSuccess: 'Cuenta creada con éxito'
    },
    taskPage: {
        desc: 'Cada recarga válida que usted invite a los miembros de nivel inferior se convertirá en su cuota de retiro (cuenta de bonificación de promoción) en una proporción determinada.',
        rwconvertRate: 'Proporción de conversión',
        totalLimit: 'Cantidad acumulada',
        availableLimit: 'Cantidad disponible',
        contactService: 'Contacto con el servicio al cliente'
    },
    Please_unlock_your_wallet: 'Por favor desbloquea tu billetera',
    Please_open_the_website_in_the_Dapp_browser: 'Abra el sitio web en el navegador Dapp.'
}
